import { Action, createReducer, on } from '@ngrx/store';

import { NotificationActions } from './notification.actions';

export interface NotificationState {
  messageKey: string | null;
  type: string | null;
}

const initialState: NotificationState = {
  messageKey: null,
  type: null,
};

const notificationReducer = createReducer(
  initialState,
  on(
    NotificationActions.addError,
    (state, { messageKey }): NotificationState => ({
      ...state,
      messageKey,
      type: 'error',
    })
  ),
  on(
    NotificationActions.addSuccess,
    (state, { messageKey }): NotificationState => ({
      ...state,
      messageKey,
      type: 'success',
    })
  ),
  on(
    NotificationActions.hide,
    (state): NotificationState => ({
      ...state,
      messageKey: null,
      type: null,
    })
  )
);

export function reducer(state: NotificationState | undefined, action: Action) {
  return notificationReducer(state, action);
}
